// extracted by mini-css-extract-plugin
export default {"rating":"gC-z","numberOfStars":"hC-z","count":"iC-z","barGraphSpacing":"jC-z","barGraph":"kC-z"};